import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Wpisz adres email');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setSent(true);
    } catch (error) {
      toast.error('Wystąpił błąd. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--crm-bg-main)] flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-[var(--crm-bg-dialog)] border-[var(--crm-border)] p-6 md:p-8">
        <div className="text-center mb-6">
          <img src="/logo.png" alt="Trendhomes" className="h-16 mx-auto mb-4" />
          <h1 className="text-2xl font-manrope font-bold text-[var(--crm-text-primary)]">
            {sent ? 'Sprawdź email' : 'Zapomniałeś hasła?'}
          </h1>
          <p className="text-[var(--crm-text-secondary)] mt-2 text-sm">
            {sent 
              ? 'Jeśli konto istnieje, wysłaliśmy link do resetu hasła.'
              : 'Wpisz swój email, a wyślemy Ci link do resetu hasła.'
            }
          </p>
        </div>

        {sent ? (
          <div className="text-center">
            <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-8 h-8 text-emerald-500" />
            </div>
            <p className="text-[var(--crm-text-secondary)] mb-6">
              Sprawdź swoją skrzynkę email (również folder SPAM) i kliknij link do resetu hasła.
            </p>
            <div className="space-y-3">
              <Button
                onClick={() => { setSent(false); setEmail(''); }}
                className="w-full bg-[var(--crm-bg-btn-secondary)] hover:bg-[var(--crm-bg-card-hover)] text-white"
              >
                Wyślij ponownie
              </Button>
              <Link to="/login" className="block">
                <Button className="w-full bg-transparent hover:bg-[var(--crm-bg-card-hover)] text-[var(--crm-text-secondary)] border border-[var(--crm-border)]">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Powrót do logowania
                </Button>
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-[var(--crm-text-secondary)]">Email</Label>
              <div className="relative mt-1">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[var(--crm-text-secondary)]" />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="twoj@email.pl"
                  className="pl-10 bg-[var(--crm-bg-panel)] border-[var(--crm-border)] text-white"
                  data-testid="forgot-password-email"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="forgot-password-submit"
              className="w-full bg-[#FF6B35] hover:bg-[var(--crm-accent-hover)] text-white"
            >
              {loading ? 'Wysyłanie...' : 'Wyślij link do resetu'}
            </Button>

            <Link to="/login" className="block">
              <Button 
                type="button"
                className="w-full bg-transparent hover:bg-[var(--crm-bg-card-hover)] text-[var(--crm-text-secondary)] border border-[var(--crm-border)]"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Powrót do logowania
              </Button>
            </Link>
          </form>
        )}
      </Card>
    </div>
  );
};
